import React from 'react';
import { Star, Phone } from 'lucide-react';
import { Button } from './Button';
export function HeroSection() {
  return <section className="bg-background-primary-light py-16 sm:py-24" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="max-w-3xl" data-id="element-100">
          <div className="inline-flex items-center gap-2 bg-neutral-white px-4 py-2 rounded-full shadow-sm mb-6" data-id="element-101">
            <div className="flex text-text-warning-default" data-id="element-102">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-103" />)}
            </div>
            <span className="text-sm font-body-semi-bold text-text-title" data-id="element-104">
              5.0 out of 5 stars
            </span>
            <span className="text-sm text-text-dimmed" data-id="element-105">(99 reviews)</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading text-text-title leading-tight mb-6" data-id="element-106">
            Jerry Gibb – Mortgage Broker in Secret Harbour
          </h1>

          <p className="text-lg sm:text-xl text-text-default mb-10 font-body leading-relaxed" data-id="element-107">
            Hello, I'm Jerry Gibb, your local Mortgage Broker in Secret Harbour
            and the surrounding areas of Mandurah and Rockingham with Coastline
            Mortgage Services.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-108">
            <a href="tel:0408247276" data-id="element-109">
              <Button variant="primary" size="lg" className="flex items-center justify-center gap-2 w-full sm:w-auto" data-id="element-110">
                <Phone className="w-5 h-5" data-id="element-111" />
                Call 0408 247 276
              </Button>
            </a>
            <a href="#contact" data-id="element-112">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-113">
                Send a message
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}